import React from 'react'
import { Autocomplete, Button, TextField } from "@mui/material";
import './CustomInterestApplicationFilter.css'
import { required } from './HelperDropdown';

function CustomInterestApplicationFilter({values,onChange,onReset,onSubmit}) {
    const inputStyles = {
        "& .MuiOutlinedInput-root": {
          padding: "0px",
          fontSize: "15px !important",
          fontFamily: "Inter",
          width: 200,
          "& .MuiAutocomplete-input": {
            padding: "7.5px 4px 7.5px 9px !important",
            fontFamily: "Inter",
          },
          "& fieldset": {
            borderColor: "rgba(119, 182, 243, 1) !important", // Change border color
          },
          "&:hover fieldset": {
            borderColor: "rgba(119, 182, 243, 1) !important", // Change border color on hover
          },
          "&.Mui-focused fieldset": {
            borderColor: "rgba(119, 182, 243, 1) !important", // Change border color when focused
          },
        },
      };
    return (
        <div style={{margin:'20px 0px'}}>
                <div className="CustomInterestApplicationFilter_input_action_container">
                    <TextField
                        name="name"
                        value={values.name}
                        fullWidth
                        className="CustomInterestApplicationFilter_input"
                        autoComplete="off"
                        style={{ fontSize: "15px" }}
                        size="small"
                        placeholder={"Enter name"}
                        onChange={onChange}
                        variant="outlined"
                        inputProps={{
                            style: {
                                padding: "3.5px 7px", // Add padding to input
                                fontSize: "15px",
                                fontWeight: 400,
                                fontFamily: "Inter",
                                borderRadius: "4px",
                            },
                        }}
                        sx={{
                            "& fieldset": { border: "none" },
                        }}
                    />
                    <TextField
                        name="email"
                        value={values.email}
                        fullWidth
                        className="CustomInterestApplicationFilter_input"
                        autoComplete="off"
                        style={{ fontSize: "15px" }}
                        size="small"
                        placeholder={"Enter email"}
                        onChange={onChange}
                        inputProps={{
                            style: {
                                padding: "3.5px 7px", // Add padding to input
                                fontSize: "15px",
                                fontWeight: 400,
                                fontFamily: "Inter",
                                borderRadius: "4px",
                            },
                        }}
                        sx={{
                            "& fieldset": { border: "none" },
                        }}
                    />
                    <TextField
                        name="contact_number"
                        value={values.contact_number}
                        fullWidth
                        className="CustomInterestApplicationFilter_input"
                        autoComplete="off"
                        style={{ fontSize: "15px" }}
                        size="small"
                        placeholder={"Enter contact number"}
                        onChange={onChange}
                        inputProps={{
                            style: {
                                padding: "3.5px 7px", // Add padding to input
                                fontSize: "15px",
                                fontWeight: 400,
                                fontFamily: "Inter",
                                borderRadius: "4px",
                            },
                        }}
                        sx={{
                            "& fieldset": { border: "none" },
                        }}
                    />
                    <Autocomplete
                            sx={{ ...inputStyles }}
                            name='loan_required'
                            id="combo-box-demo"
                            options={ required }
                            getOptionLabel={(option) => option.label}
                            onChange={(event, newValue) => {
                                let target={name:'loan_required',value:newValue?newValue.value:''}
                                onChange({target:target})
                              }}
                            value={
                                required.find(
                                  (type) => type.value === values.loan_required
                                ) || null
                              }
                            ListboxProps={{
                            style: {
                                minHeight: 0,
                                fontSize: 15,
                                fontFamily: "Inter",
                                border: "0.5px solid rgba(119, 182, 243, 1) !important",
                            },
                            }}
                            menuProps={{ style: { minHeight: 0, fontFamily: "Inter" } }}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label=""
                                placeholder="Loan Required"
                                style={{ fontFamily: "Inter" }}
                            />
                            )}
                        />
                         <Autocomplete
                            sx={{ ...inputStyles }}
                            disablePortal
                            id="combo-box-demo"
                            options={required}
                            getOptionLabel={(option) => option.label}
                            onChange={(event, newValue) => {
                                let target={name:'visit_required',value:newValue?newValue.value:''}
                                onChange({target:target})
                              }}
                              value={
                                required.find(
                                  (type) => type.value === values.visit_required
                                ) || null
                              }
                            ListboxProps={{
                            style: {
                                minHeight: 0,
                                fontSize: 15,
                                fontFamily: "Inter",
                                border: "0.5px solid rgba(119, 182, 243, 1) !important",
                            },
                            }}
                            menuProps={{ style: { minHeight: 0, fontFamily: "Inter" } }}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label=""
                                placeholder="Visit Required"
                                style={{ fontFamily: "Inter" }}
                            />
                            )}
                        />
                    <div className="CustomInterestApplicationFilter_action">
                        <Button
                            className="users_Search_button"
                            onClick={onSubmit}
                            variant="contained"
                            size="small"
                            style={{
                                textTransform: "none",
                                textTransform: "none",
                                fontFamily: "Inter",
                                fontSize: "15px",
                                fontStyle: "normal",
                                fontWeight: 600,
                                lineHeight: "normal",
                                padding: "8px 15px",
                                backgroundColor: "#0f62fe",
                                color: "white",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer"
                            }}
                        >
                            {"Search"}
                        </Button>
                        <Button
                            onClick={onReset}
                            className="users_Reset_button"
                            variant="outlined"
                            size="small"
                            style={{
                                textTransform: "none",
                                cursor: 'pointer',
                                fontFamily: 'inter',
                                border: '1px solid #005eb8',
                                backgroundColor: 'white',
                                borderRadius: '5px',
                                padding: '7px 25px',
                                color: '#0f62fe',
                                fontSize: '14px'
                            }}

                        >
                            {"Reset"}
                        </Button>
                    </div>
                </div>
            </div>
    )
}

export default CustomInterestApplicationFilter